import React, { useState } from 'react';
import PropType from 'prop-types';

import { useDebounce } from '../../../../../core/hooks';
import { updateStudyMutation } from '../../../../../core/services/graphql-requests';

import {
  Row,
  Column,
  FieldName,
  Form,
  Input,
  TextArea,
} from '../styles';

const DEBOUNCE_TIME = 700;

const EditProjectForm = (props) => {
  const { project } = props;
  const {
    name,
    description,
    id,
  } = project;
  const isDemoProject = id === '00000000-0000-0000-0000-000000000000';

  const [projectName, setProjectName] = useState(name);
  const [projectDescription, setProjectDescription] = useState(description);

  const handleClickOut = () => {
    if (projectName.length < 1) {
      setProjectName(name);
    }
  };

  useDebounce(async () => {
    if (!isDemoProject && projectName.length > 0 && (projectName !== name || projectDescription !== description)) {
      const attributesProject = {
        name: projectName,
        description: projectDescription,
      };

      await updateStudyMutation(id, attributesProject);
    }
  }, DEBOUNCE_TIME, [projectName, projectDescription]);

  return (
    <>
      <Row>
        <Column computer={4} tablet={4} mobile={8}>
          <FieldName>
            Project Name
          </FieldName>
        </Column>
        <Column computer={12} tablet={12} mobile={8}>
          <Input
            value={projectName}
            onChange={(x, { value }) => setProjectName(value)}
            fluid
            onBlur={handleClickOut}
          />
        </Column>
      </Row>

      <Row>
        <Column computer={4} tablet={4} mobile={8}>
          <FieldName>Description</FieldName>
        </Column>
        <Column computer={12} tablet={12} mobile={8}>
          <Form>
            <TextArea
              size="mini"
              value={projectDescription}
              placeholder="Enter a description"
              onChange={(x, { value }) => setProjectDescription(value)}
              fluid="true"
              rows={3}
            />
          </Form>
        </Column>
      </Row>
    </>
  );
};

EditProjectForm.propTypes = {
  project: PropType.shape({
    name: PropType.string,
    description: PropType.string,
    id: PropType.string,
  }).isRequired,
};

export default EditProjectForm;
